// Privacy Policy 页面相关的翻译资源
export const privacyPolicyResources = {
  zh: {
    // Privacy Policy page
    "privacyPolicy.content": `**本隐私声明的适用范围**

Genovation Foundation Limited（创生基金有限公司）致力于保护个人数据。本隐私声明将告知您我们如何通过您使用本网站收集和使用您的个人数据，包括您注册我们的通讯或通过本网站联系我们时可能提供的任何数据。  
本声明最后更新于2025年11月20日。

**我们是谁**

创生基金由携程集团联合创始人梁建章博士个人在香港设立，地址为香港尖沙咀港威大厦2座35楼3501-06及12室，旨在通过三个关键途径探索解决方案：经济补贴、政策研究支持和文化倡导。  
本声明由创生基金发布。当我们在本声明中提及创生基金、"我们"或"我们的"时，我们指的是负责处理您数据的创生基金有限公司。  
如需联系我们，请发送电子邮件至 _info@genovationfoundation.org_。  
您有权随时就数据保护问题向您当地的监管机构提出投诉；但是，我们希望有机会处理您的关切，因此请首先联系我们。

**我们收集的关于您的数据**  

个人数据是指能够识别个人身份的任何信息。我们可能收集、使用、存储和传输不同类型的个人数据，包括：

**您直接向我们提供的信息：**

- **联系数据**：全名（与您的学生证一致）、电子邮件地址、香港特别行政区电话号码。
- **申请数据**：大学名称、研究项目名称、子女出生日期、资助方式、学生证照片（包括您的姓名、照片、学号、课程和注册年份）、学校成绩单/入学证明（包括您的姓名、学号和签发日期）、子女出生证明（包括父母姓名、子女出生日期和地点）、银行账户信息（包括银行名称、持卡人姓名和银行账户）。
- 我们在平台上另行告知您并获得您同意的其他必要数据。

如果您未能提供上述必要数据，我们将无法满足您的请求或向您提供相关服务。  
如果您代表他人提供他人的个人数据，您有责任确保他们知道您已这样做，并已同意您为本声明中的目的与我们分享他们的个人数据。  
如果您提供18岁以下未成年人的个人数据，请确保您已根据适用法律获得未成年人监护人的同意。

**我们如何使用您的个人数据**  

| 目的    | 法律依据    |
|----------|----------|
| 审查和回应您的申请    | 我们有必要处理您的个人数据以履行与您的合同，或在您的要求下在与您签订合同之前采取步骤。&nbsp;<br>如适用法律要求，需获得同意&nbsp; |
| 发放资助    | 我们有必要处理您的个人数据以履行与您的合同，或在您的要求下在与您签订合同之前采取步骤。&nbsp;<br>如适用法律要求，需获得同意。&nbsp; |
| 客户服务    | 我们有必要处理您的个人数据以履行与您的合同，或在您的要求下在与您签订合同之前采取步骤。&nbsp;<br>我们也有管理业务和向您提供客户服务的合法利益。 |
| 欺诈检测和预防、支付验证、提高服务安全性和可靠性    | 我们有确保我们运营、资产以及与我们的服务互动的个人安全的合法利益。 |
| 遵守我们的法律义务和监管要求，以及用于调查、投诉管理和争议解决    | 遵守法律义务所必需。&nbsp;<br>我们也有保护我们和您的商业利益和法律权利以及您的利益和法律权利的合法利益。 |

**个人数据的披露**  

我们可能为上述目的与以下各方共享您的个人数据：  
- 与我们签订合同以代表我们提供服务或功能的第三方供应商，如IT和法律服务、业务分析、客户服务和欺诈预防。
- 适用法律要求的监管机构和其他当局。

**我们使用个人数据的期限**  

我们只会在合理必要的时间内保留您的个人数据，以完成我们收集数据的目的，包括满足任何法律或监管要求。如果发生投诉，或者我们合理认为存在与我们与您的关系相关的诉讼前景，我们可能会在更长时间内保留您的个人数据。  
为确定个人数据的适当保留期限，我们会考虑个人数据的数量、性质和敏感性，未经授权使用或披露您的个人数据的潜在风险，我们处理您的个人数据的目的以及我们是否可以通过其他方式实现这些目的，以及适用的法律、监管或其他要求。

**您的法律权利**  

根据适用法律，您拥有与您的数据相关的权利，可能包括访问、更正或删除您的数据的权利，以及对处理您的数据提出异议、限制或撤回同意的权利。如果您对处理您的数据提出异议或撤回同意，或以其他方式要求限制或删除，那么您将无法再享受我们的服务。如果您希望行使任何这些权利，请通过 _info@genovationfoundation.org_ 联系我们。
    `,
  },
  zh_TW: {
    // Privacy Policy page
    "privacyPolicy.content": `**本隱私聲明的適用範圍**

Genovation Foundation Limited（創生基金有限公司）致力於保護個人資料。本隱私聲明將告知您我們如何透過您使用本網站收集和使用您的個人資料，包括您註冊我們的通訊或透過本網站聯繫我們時可能提供的任何資料。  
本聲明最後更新於2025年11月20日。

**我們是誰**

創生基金由攜程集團聯合創始人梁建章博士個人在香港設立，地址為香港尖沙咀港威大廈2座35樓3501-06及12室，旨在透過三個關鍵途徑探索解決方案：經濟補貼、政策研究支持和文化倡導。  
本聲明由創生基金發布。當我們在本聲明中提及創生基金、"我們"或"我們的"時，我們指的是負責處理您資料的創生基金有限公司。  
如需聯繫我們，請發送電子郵件至 _info@genovationfoundation.org_。  
您有權隨時就資料保護問題向您當地的監管機構提出投訴；但是，我們希望有機會處理您的關切，因此請首先聯繫我們。

**我們收集的關於您的資料**  

個人資料是指能夠識別個人身分的任何資訊。我們可能收集、使用、儲存和傳輸不同類型的個人資料，包括：

**您直接向我們提供的資訊：**

- **聯繫資料**：全名（與您的學生證一致）、電子郵件地址、香港特別行政區電話號碼。
- **申請資料**：大學名稱、研究項目名稱、子女出生日期、資助方式、學生證照片（包括您的姓名、照片、學號、課程和註冊年份）、學校成績單/入學證明（包括您的姓名、學號和簽發日期）、子女出生證明（包括父母姓名、子女出生日期和地點）、銀行帳戶資訊（包括銀行名稱、持卡人姓名和銀行帳戶）。
- 我們在平台上另行告知您並獲得您同意的其他必要資料。

如果您未能提供上述必要資料，我們將無法滿足您的請求或向您提供相關服務。  
如果您代表他人提供他人的個人資料，您有責任確保他們知道您已這樣做，並已同意您為本聲明中的目的與我們分享他們的個人資料。  
如果您提供18歲以下未成年人的個人資料，請確保您已根據適用法律獲得未成年人監護人的同意。

**我們如何使用您的個人資料**  

| 目的    | 法律依據    |
|----------|----------|
| 審查和回應您的申請    | 我們有必要處理您的個人資料以履行與您的合約，或在您的要求下在與您簽訂合約之前採取步驟。&nbsp;<br>如適用法律要求，需獲得同意&nbsp; |
| 發放資助    | 我們有必要處理您的個人資料以履行與您的合約，或在您的要求下在與您簽訂合約之前採取步驟。&nbsp;<br>如適用法律要求，需獲得同意。&nbsp; |
| 客戶服務    | 我們有必要處理您的個人資料以履行與您的合約，或在您的要求下在與您簽訂合約之前採取步驟。&nbsp;<br>我們也有管理業務和向您提供客戶服務的合法利益。 |
| 詐欺檢測和預防、支付驗證、提高服務安全性和可靠性    | 我們有確保我們營運、資產以及與我們的服務互動的個人安全的合法利益。 |
| 遵守我們的法律義務和監管要求，以及用於調查、投訴管理和爭議解決    | 遵守法律義務所必需。&nbsp;<br>我們也有保護我們和您的商業利益和法律權利以及您的利益和法律權利的合法利益。 |

**個人資料的披露**  

我們可能為上述目的與以下各方共享您的個人資料：  
- 與我們簽訂合約以代表我們提供服務或功能的第三方供應商，如IT和法律服務、業務分析、客戶服務和詐欺預防。
- 適用法律要求的監管機構和其他當局。

**我們使用個人資料的期限**  

我們只會在合理必要的時間內保留您的個人資料，以完成我們收集資料的目的，包括滿足任何法律或監管要求。如果發生投訴，或者我們合理認為存在與我們與您的關係相關的訴訟前景，我們可能會在更長時間內保留您的個人資料。  
為確定個人資料的適當保留期限，我們會考慮個人資料的數量、性質和敏感性，未經授權使用或披露您的個人資料的潛在風險，我們處理您的個人資料的目的以及我們是否可以透過其他方式實現這些目的，以及適用的法律、監管或其他要求。

**您的法律權利**  

根據適用法律，您擁有與您的資料相關的權利，可能包括存取、更正或刪除您的資料的權利，以及對處理您的資料提出異議、限制或撤回同意的權利。如果您對處理您的資料提出異議或撤回同意，或以其他方式要求限制或刪除，那麼您將無法再享受我們的服務。如果您希望行使任何這些權利，請透過 _info@genovationfoundation.org_ 聯繫我們。
    `,
  },
  en: {
    // Privacy Policy page
    "privacyPolicy.content": `**WHEN THIS PRIVACY STATEMENT APPLIES**

Genovation Foundation Limited is committed to protecting personal data. This privacy statement will inform you as to how we collect and use your personal data through your use of this website, including any data you may provide when you sign up to our newsletter or contact us via this website.  
This statement was last updated on 20 Nov 2025.

**WHO WE ARE**

Genovation Foundation is personally established by Dr James Liang, Co-founder of Trip.com Group, with its address at Suites 3501-06 & 12, 35/F, Tower 2, The Gateway, Tsim Sha Tsui, Hong Kong, to explore solutions through three key avenues: economic subsidies, support for policy research, and cultural advocacy.  
This statement is issued by Genovation Foundation. When we mention Genovation Foundation, "we", "us" or "our" in this statement, we are referring to Genovation Foundation Limited which is responsible for processing your data.  
To contact us, please email _info@genovationfoundation.org_.  
You have the right to make a complaint at any time to your local supervisory authority for data protection issues; however, we would appreciate the chance to deal with your concerns, so please contact us in the first instance.

**THE DATA WE COLLECT ABOUT YOU**  

Personal data means any information about an individual from which that person can be identified. We may collect, use, store and transfer different kinds of personal data, including:

**Information you have provided to us directly:**

- **Contact Data**: full name (same as your student ID card), email address, Hong Kong SAR telephone number.
- **Application Data**: University name, research project name, child's date of birth, funding method, picture of your student ID card (including your name, photo, student ID number, courses and year of registration), school transcript/proof of enrolment (including your name, student ID number and issue date), child's birth certificate (including parents' names, child's date and place of birth), bank account information (including bank name, cardholder name and bank account).
- Other necessary data that we separately inform you and obtain your consent on our platform.

If you fail to provide the above necessary data, we will be unable to facilitate your request or provide relevant service to you.  
If you provide others' personal data on their behalf, it is your responsibility to ensure that they are aware that you've done so, and have agreed to your sharing of their personal data with us for the purposes in this statement.  
If you provide personal data of minors under 18, please ensure that you have obtained the consent of the minor's guardian in accordance with applicable laws.

**HOW WE USE YOUR PERSONAL DATA**  

| Purpose    | Legal Basis    |
|----------|----------|
| Review and respond to your application    | It is necessary for us to process your personal data to perform our contract with you, or to take steps at your request prior to entering into a contract with you. <br>Consent if required under the applicable law&nbsp; |
| Grant disturbance    | It is necessary for us to process your personal data to perform our contract with you, or to take steps at your request prior to entering into a contract with you.  <br>Consent if required under the applicable law.&nbsp; |
| Customer service    | It is necessary for us to process your personal data in order to perform our contract with you, or to take steps at your request prior to entering into a contract with you.  <br>We also have a legitimate interest in managing our business and providing you customer service. |
| Fraud detection and prevention, payment verification, improving service security and reliability    | We have a legitimate interest in ensuring the security of our operations, assets, and individuals interacting with our services. |
| Comply with our legal obligations and regulatory requirements, and for investigations, complaints management and dispute resolution    | Necessary to comply with legal obligations.  <br>We also have a legitimate interest in protecting our business interests and legal rights, and your interests and legal rights. |

**DISCLOSURES OF PERSONAL DATA**  

We may share your personal data with following parties for the purposes set out in above:  
- Third party vendors under contract to us to provide services or functions on our behalf, such as IT and legal services, business analytics, customer service and fraud prevention.
- Regulators and other authorities as required by the applicable laws.

**HOW LONG WE USE PERSONAL DATA FOR**  

We will only retain your personal data for as long as reasonably necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal or regulatory requirements. We may retain your personal data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with you.  
To determine the appropriate retention period for personal data, we consider the amount, nature and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory or other requirements.

**YOUR LEGAL RIGHTS**  

According to applicable laws, you have the rights concerning your data, which may include the right to access, rectify or erase your data, as well as the right to object to, restrict or withdraw consent for the processing of your data. If you object to or withdraw consent for the processing of your data, or otherwise request restriction or deletion, then you will no longer be able to enjoy our services. If you wish to exercise any of these rights, please contact us at _info@genovationfoundation.org_.
    `,
  }
};

